export function useTermsPrivacyService() {
  const isModalClosed = useState('termsprivacy-modal', () => false);

  const setTermsPrivacyModalState = (value = false) => {
    isModalClosed.value = value;
  };

  const getTermsPrivacyModalState = () => {
    return isModalClosed.value;
  };

  return { getTermsPrivacyModalState, setTermsPrivacyModalState };
}
